const React = require("react");

require("./ContentBlock.less");

const ContentBlock = React.createClass({     
    render() {        
        return <div className="cs-ContentBlock">{this.props.children}</div>
    }
})

module.exports = ContentBlock;


// WEBPACK FOOTER //
// ./src/components/ContentBlock/ContentBlock.jsx